import { addSpaceIfNeeded } from "./addSpaceIfNeeded";
import { getGridElementSize } from "./getGridElementSize";
import { sortLayout } from "./sortLayout";

export const addElementsToLayout = async (
  elementsToAdd,
  layout,
  format,
  hiddenGridElements,
  skipSeparatorsFiltering,
) => {
  const elements = Array.isArray(elementsToAdd)
    ? elementsToAdd
    : [elementsToAdd];

  let spaceY = 0;

  const filteredLayout = skipSeparatorsFiltering
    ? layout
    : layout.filter((item) => !item.i.includes("separator"));
  const sortedLayout = sortLayout([...filteredLayout]);

  elements.forEach((element) => {
    const { label: id, gridBoxType: provider, campaignId } = element;

    const metricType = id
      .replace(`${provider}-`, "")
      .replace(`-${campaignId}`, "");

    const lastEl = addSpaceIfNeeded(metricType, sortedLayout, format);

    const spaceOnPage = format.rows;
    const currentRow = lastEl.y + lastEl.h;
    const spaceLeftY = spaceOnPage - (currentRow % spaceOnPage) - 1;

    const spaceX = format.cols - (lastEl.x + lastEl.w);
    if (spaceX !== 0) {
      spaceY = lastEl.h;
    }

    const size = getGridElementSize(
      id,
      provider,
      hiddenGridElements,
      format,
      metricType,
      element,
    );

    const i = id;
    const { w, h } = size;
    let x = 0;
    let y = 0;

    // Adding element in the right place

    const { x: emptyX, y: emptyY } = getEmptySpacePosition(w, h, format.cols, [
      sortedLayout[sortedLayout.length - 1],
    ]);

    x = emptyX;
    y = emptyY;

    let nextSeparator = lastEl.y + lastEl.h + spaceLeftY;

    if (isNaN(x) || isNaN(y)) {
      if (spaceX >= size.w && spaceY >= size.h) {
        x = lastEl.x + lastEl.w;
        y = lastEl.y;
      } else if (spaceLeftY >= size.h) {
        x = 0;
        y = lastEl.y + lastEl.h;
      } else {
        x = 0;
        y = nextSeparator + 1;
      }
    }

    if (i.includes("header-2-top-publication")) {
      const publicationsInLayout = layout.filter(
        (item) =>
          item.i.slice(0, 11) === "publication" ||
          item.i.slice(0, 15) === "top-publication" ||
          item.i.slice(0, 24) === "header-2-top-publication",
      );

      if (publicationsInLayout.length) {
        const lastElementEndY =
          Math.max(...publicationsInLayout.map((item) => item.y)) + 7;
        y = lastElementEndY + (format.rows - (lastElementEndY % format.rows));
      } else {
        y = nextSeparator + 1;
      }
    }

    if (y > nextSeparator) {
      nextSeparator += y % format.rows;
    }

    const newElement = { i, x, y, w, h };
    layout.push(newElement);
    sortedLayout.push(newElement);
  });

  return sortedLayout;
};

const getEmptySpacePosition = (w, h, cols, layout) => {
  let x;
  let y;

  for (let i = 0; i < layout.length - 1; i++) {
    const elA = layout[i];
    const elB = layout[i + 1];
    const endXA = elA.x + elA.w;
    const endYA = elA.y + elA.h;
    const endYB = elB.y + elB.h;

    const equalY = elA.y === elB.y;
    const equalH = elA.h === elB.h;

    // Equal position Y and height
    if (equalY && equalH) {
      if (elB.x - endXA >= w) {
        x = endXA;
        y = elA.y;
        break;
      }
    }

    // Element B in next row
    if (endYA <= elB.y) {
      const enoughX = cols - endXA >= w;
      const enoughY = elB.y - endYA >= h;
      if (enoughX && enoughY) {
        x = endXA;
        y = elA.y;
        break;
      } else if (
        w <= elB.x &&
        h <= elB.h &&
        (elA.x !== elB.x || endYA <= elB.y)
      ) {
        x = 0;
        y = elB.y;
        break;
      } else if (elB.y - endYA >= h) {
        x = 0;
        y = endYA;
        break;
      }
    }
    // Space between rows
    if (endXA === cols && elB.x === 0 && elB.y - endYA > 0) {
      if (elB.y - endYA >= h) {
        x = 0;
        y = endYA;
        break;
      }
    }

    if (elB.x === 0) {
      if (cols - endXA >= w && elA.h >= h) {
        x = endXA;
        y = elA.y;
        break;
      }

      if (elB.y - endYA >= h) {
        x = 0;
        y = endYA;
        break;
      }
    }

    if (endXA <= elB.x && endYB - endYA >= h) {
      x = elA.x;
      y = endYA;
      break;
    }
  }

  return { x, y };
};
